<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18Pwo03/tc-custom/9781649792426.jpg?1705056298014" alt="This image is the cover for the book An Afternoon in the Garden"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">An Afternoon in the Garden
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Arial Nova",sans-serif;'>Take a walk through a garden and take delight in the thriving vegetable garden and the blooming fragrance of the flower garden. <em>An Afternoon in the Garden</em> provides discovery and comfort for mother and child in their own backyard. Allow all five senses to take in the beauty and life-giving produce of fruits and vegetables. Enjoy what nature does best through plentiful rains, bountiful sunshine, and the hard work of a gardener!</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jane Tradup
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-family:"Times New Roman",serif;'>Jane Tradup worked as a registered nurse for 23 years before trying her hand at writing children&rsquo;s stories. She is an ardent animal lover and enjoys the outdoors. She resides in the Minneapolis, Minnesota area with her spouse, one dog, and one cat.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?89da07ba